
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/sneeuwbericht-reacties",
      function () {
        return require("private-next-pages/[region]/[resort]/sneeuwbericht-reacties.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/sneeuwbericht-reacties"])
      });
    }
  